import { CONTACT } from "@/lib/constants";

export default function Privacy() {
    return (
        <div data-testid="privacy-page" className="container-tight py-16 md:py-24 max-w-3xl">
            <div className="eyebrow">Legal</div>
            <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter text-white mt-3">Privacy Policy</h1>
            <p className="text-zinc-500 mt-3 text-sm">Last updated: February 19, 2026</p>

            <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed">
                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">1. Who we are</h2>
                    <p>
                        All About Printers (&quot;we&quot;, &quot;us&quot;) is an independent editorial publication providing printer reviews,
                        buying guides, and troubleshooting FAQs for informational and educational purposes. You can reach us by
                        phone at {CONTACT.phoneDisplay} or by email at {CONTACT.email}.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">2. Information we collect</h2>
                    <p>We only collect information you voluntarily provide, and a small amount of technical data required to run the site:</p>
                    <ul className="list-disc pl-6 mt-3 space-y-2">
                        <li><strong className="text-white">Contact form submissions:</strong> your name, email, optional phone number, topic of interest, and message.</li>
                        <li><strong className="text-white">Cookies:</strong> essential cookies for basic site functionality and, if you consent, analytics cookies to understand aggregate usage patterns.</li>
                        <li><strong className="text-white">Server logs:</strong> IP address, browser user-agent, and requested URL — retained for up to 30 days for security and diagnostics.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">3. How we use your information</h2>
                    <ul className="list-disc pl-6 mt-2 space-y-2">
                        <li>To respond to your questions and requests submitted through the contact form.</li>
                        <li>To improve the content and functionality of the site.</li>
                        <li>To detect and prevent abuse or spam.</li>
                    </ul>
                    <p className="mt-3">We do not sell your personal information, and we do not share it with third parties for marketing purposes.</p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">4. Advertising and analytics</h2>
                    <p>
                        We may use Google Ads and analytics products (including Google Analytics) to understand
                        aggregate visitor behavior and, where applicable, to measure the effectiveness of
                        our advertising campaigns. These services may set their own cookies and collect
                        anonymized usage data in accordance with their own privacy policies. You can opt out
                        of Google&apos;s use of cookies by visiting{" "}
                        <a className="text-blue-400 hover:text-blue-300" href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
                            Google Ads Settings
                        </a>.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">5. Affiliate and editorial disclosure</h2>
                    <p>
                        Some links on this site may be affiliate links. If you click and purchase, we may receive a small commission at no additional cost to you.
                        Affiliate relationships never influence our editorial ratings or recommendations — we test what we recommend, and we recommend what we would buy.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">6. Your rights</h2>
                    <p>
                        Depending on your jurisdiction, you may have the right to access, correct, or delete personal information we hold about you,
                        or to object to certain processing. To exercise these rights, contact us at {CONTACT.email} or by calling {CONTACT.phoneDisplay}.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">7. Data retention</h2>
                    <p>
                        Contact form submissions are retained for as long as needed to respond and follow up, typically no longer than 24 months.
                        You may request deletion at any time.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">8. Children</h2>
                    <p>This site is not directed at children under 13, and we do not knowingly collect information from children.</p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">9. Changes to this policy</h2>
                    <p>We may update this policy from time to time. Material changes will be noted at the top of this page with a new &quot;last updated&quot; date.</p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">10. Contact</h2>
                    <p>
                        Questions about this policy? Email {CONTACT.email} or call {CONTACT.phoneDisplay} during business hours ({CONTACT.hours}).
                    </p>
                </section>
            </div>
        </div>
    );
}
